import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { loadTreatment } from '@surfline/web-common/dist/features/redux';

import CamList from '../CamList';
import CamListError from '../CamListError';
import MotionScrollWrapper from '../MotionScrollWrapper';

import { getUserSettings } from '../../selectors/user';
import { getCamListScrollPosition } from '../../selectors/animations';
import { getSpotMultiCam, getNearbySpots, getReverseSortBeachView } from '../../selectors/spot';

import { trackEvent } from '../../actions/segmentEvents';
import { setCamListScrollPosition } from '../../actions/animations';

import scrollPositionPropType from '../../propTypes/animations/scrollPosition';
import userSettingsPropTypes from '../../propTypes/userSettings';

const NearbyCams = ({
  nearbySpots,
  nearbySpotsError,
  camListScrollPosition,
  reverseSortBeachView,
  doSetCamListScrollPosition,
  userSettings,
  doTrackEvent,
  isPremium,
  spotId,
}) => (
  <div className="sl-spot-report-cam__nearby-cams">
    {nearbySpots ? (
      <MotionScrollWrapper scrollPosition={camListScrollPosition}>
        <CamList
          spots={reverseSortBeachView ? [...nearbySpots].reverse() : nearbySpots}
          spotId={spotId}
          doSetCamListScrollPosition={doSetCamListScrollPosition}
          units={userSettings.units.surfHeight}
          doTrackEvent={doTrackEvent}
          isPremium={isPremium}
        />
      </MotionScrollWrapper>
    ) : null}
    {nearbySpotsError ? <CamListError /> : null}
  </div>
);

NearbyCams.defaultProps = {
  isPremium: false,
  nearbySpots: null,
  reverseSortBeachView: null,
  userSettings: null,
};

NearbyCams.propTypes = {
  isPremium: PropTypes.bool,
  userSettings: userSettingsPropTypes,
  spotId: PropTypes.string.isRequired,
  nearbySpots: PropTypes.arrayOf(PropTypes.shape()),
  nearbySpotsError: PropTypes.bool.isRequired,
  reverseSortBeachView: PropTypes.bool,
  doSetCamListScrollPosition: PropTypes.func.isRequired,
  doTrackEvent: PropTypes.func.isRequired,
  camListScrollPosition: scrollPositionPropType.isRequired,
};

export default connect(
  state => ({
    multiCam: getSpotMultiCam(state),
    nearbySpots: getNearbySpots(state),
    nearbySpotsError: !!state.spot.nearby.error,
    reverseSortBeachView: getReverseSortBeachView(state),
    userSettings: getUserSettings(state),
    camListScrollPosition: getCamListScrollPosition(state),
  }),
  dispatch => ({
    doTrackEvent: (event, properties) => dispatch(trackEvent(event, properties)),
    doLoadTreatments: treatment => dispatch(loadTreatment(treatment)),
    doSetCamListScrollPosition: scrollPosition =>
      dispatch(setCamListScrollPosition(scrollPosition)),
  })
)(NearbyCams);
